var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27309_112784)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7381 12.529C29.0018 11.3494 31.8045 12.2087 32.9959 14.449C34.1873 16.6892 33.3182 19.4607 31.0545 20.6404L29.1932 21.6189C30.7967 21.6775 32.326 22.5583 33.1268 24.0642C34.3182 26.3044 33.451 29.0759 31.1854 30.2556L21.2596 35.4704C18.9959 36.6501 16.1932 35.7908 15.0018 33.5505C13.8104 31.3103 14.6795 28.5388 16.9432 27.3591L18.8045 26.3806C17.201 26.322 15.6717 25.4412 14.8709 23.9353C13.6795 21.6951 14.5486 18.9236 16.8123 17.7439L26.7381 12.529ZM21.3807 20.3064L27.3885 24.0154L21.3807 27.7068V20.3064Z",
    fill: "#9A9AAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27309_112784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3242,
    height: 24,
    fill: "white",
    transform: "translate(14.3379 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIndicator);
export default __webpack_public_path__ + "static/media/video-indicator.4dfdc7cf2541b864f7e4db01eaa3a342.svg";
export { ForwardRef as ReactComponent };